import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { supabase, isSupabaseConfigured } from '@/lib/supabase';
import { AuthShell, authInput, authButton, PasswordInput } from '@/components/AuthShell';
import { GoogleAuthButton, OrDivider } from '@/components/GoogleAuthButton';

export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const rawNext = params.get('next') || '/app';
  const next = rawNext.startsWith('/') && !rawNext.startsWith('//') ? rawNext : '/app';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!isSupabaseConfigured) return;
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) toast.error(error.message);
    else { toast.success('Connecté !'); navigate(next); }
  };

  return (
    <AuthShell title="Connexion" subtitle="Ravi de te revoir sur MyMusic IA."
               footer={<>Pas encore de compte ? <Link to="/register" className="text-brand hover:underline">Créer un compte</Link></>}>
      <GoogleAuthButton next={next} testId="login-google" />
      <OrDivider />
      <form onSubmit={submit} className="space-y-4">
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} data-testid="login-email" />
        <PasswordInput required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        <div className="text-right">
          <Link to="/forgot-password" className="text-xs text-muted-foreground hover:text-brand">Mot de passe oublié ?</Link>
        </div>
        <button type="submit" disabled={busy || !isSupabaseConfigured} className={authButton} data-testid="login-submit">
          {busy ? <Loader2 className="mx-auto h-5 w-5 animate-spin" /> : 'Se connecter'}
        </button>
      </form>
    </AuthShell>
  );
}
